import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { GetScans } from '../../../state/scanner/scanner.actions';
import { Store } from '@ngrx/store';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ViewJsonComponent } from '../view-json/view-json.component';
import { Subscription } from 'rxjs';
import { ReprocessDocument } from '../../../state/diagnostics/diagnostics.actions';
import { MatCardTitle } from '@angular/material/card';
import { MatToolbar } from '@angular/material/toolbar';
import { MatFormField, MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { ThrottleClickDirective } from '@drc-eca/eca-lrc-common-ui';
import { DatePipe } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { TABLE_BASE_COMMON_IMPORTS } from '../../material-base-common-imports';

@Component({
  selector: 'eca-scans-table',
  templateUrl: './scans-table.component.html',
  styleUrls: ['./scans-table.component.css'],
  imports: [MatCardTitle, MatToolbar, MatFormField, MatInput, MatSort, RouterLink, MatButton, ThrottleClickDirective, MatTooltip, MatIcon, DatePipe, ...TABLE_BASE_COMMON_IMPORTS]
})
export class ScansTableComponent implements OnInit {
  private router = inject(Router);
  private _route = inject(ActivatedRoute);
  private _store = inject<Store<any>>(Store);
  private _dialog = inject(MatDialog);


  @Input() sessionId: string;
  @Input() lithocode: string;
  scansDataSource: MatTableDataSource<any[]>;
  JSON: any = JSON;
  inputResults: any;

  scanColumnsToDisplay: string[] = ['status', 'error', 'completedAt', 'client', 'districtCode', 'schoolCode',
    'testFamily', 'materialId', 'lithocode', 'pageNumber', 'checkDigit', 'id', 'backsideId',
    'inputsProcessed', 'demographicResults', 'inputResults', 'generateDebugImage', 'debugImages'];
  config$: Subscription = new Subscription();

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  ngOnInit() {
    this.sessionId = this._route.snapshot.params.sessionId;
    this._store.dispatch(new GetScans({sessionId: this.sessionId, populateAllFields: true}));
    this._store.select('scans').subscribe((scans: any) => {
      this.scansDataSource = new MatTableDataSource(scans.scans);
      this.sort.direction = 'asc';
      this.sort.active = 'pageNumber';
      this.scansDataSource.sort = this.sort;
    });
  }

  openDialog(description: string, content: string) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      description,
      content,
    };
    this._dialog.open(ViewJsonComponent, dialogConfig);
  }
  doFilter(filterValue: string) {
    this.scansDataSource.filter = filterValue.trim().toLowerCase();
  }

  /* istanbul ignore next simple method */
  encodeURI(scanId: string) {
    return encodeURIComponent(scanId);
  }

  generateDebugImages(id, backsideId) {
    this._store.dispatch(new ReprocessDocument({ result: { scanIds: [id, backsideId] }, sessionId: this.sessionId, debug: true }));
  }

  debugImages(id) {
    console.log('debugImages', id);
    this.router.navigate([encodeURIComponent(id)], { relativeTo: this._route });
  }
}
